import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-charcoal text-parchment flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="glass rounded-3xl p-10 max-w-md w-full text-center">
        <XCircle className="w-12 h-12 text-mist mx-auto" data-testid="cancel-icon" />
        <h1 className="mt-6 font-display font-bold text-2xl">Checkout cancelled</h1>
        <p className="mt-3 text-sm text-mist leading-relaxed">
          No charge was made. Whenever you're ready, your doorstep is waiting.
        </p>
        <Link to="/#pricing" data-testid="cancel-back-link"
          className="mt-8 inline-flex items-center gap-2 bg-terracotta hover:bg-parchment hover:text-charcoal text-parchment text-sm font-semibold px-8 py-3.5 rounded-full transition-colors duration-300">
          <ArrowLeft className="w-4 h-4" /> Back to Plans
        </Link>
      </motion.div>
    </main>
  );
}
